// extracted by extract-css-chunks-webpack-plugin
module.exports = {"right":"dashboard-right__right--3y8Y0"};